import React, { useEffect, useMemo, useState } from "react";
import { GetAllRequest } from "apis/api-types";
import {
  useCountSearchMutation,
  useGetCategoryUserSideQuery,
  useLazyGetPopularTopicQuery,
  useGetSearchBarQuery,
  useGetSubCategoryUserSideQuery,
  useLazyGetSearchTitleQuery,
  useLazyGetArticleBySlugUrlQuery,
  useLazyGetArticlePuslishedBySlugUrlQuery,
  useGetSubCategoryUserSideSlugUrlQuery,
} from "apis/userSide/homeUserSide";
import ROUTERS_PATHS from "consts/router-paths";

import { useSearchParams } from "react-router-dom";
import { useGetCustomTableState } from "redux/customTable/customTableSlice";
import getOptionsLoadMore from "utils/getOptionLoadMore";
import sortBy from "lodash/sortBy";
import { useSetToastNotificationState } from "redux/toastNotification/toastNotificationSlice";
import moment from 'moment-timezone';

export interface IDataCategory {
  name: string;
  shortName: string;
  slugUrl: string;
  ordinalNumber: number;
  iconUrl: string;
  isHighlight: boolean;
  access: number;
  status: number;
  parentCategoryId?: string;
  articles: any[];
  subCategories: SubCategory[];
  privateUsers: any[];
  autoApply: boolean;
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
  id: string;
}

interface IDataSubCategory {
  name: string;
  slugUrl: string;
  ordinalNumber: number | string;
  iconUrl: string;
  isHighlight: boolean;
  access: number;
  status: number;
  parentCategoryId: string;
  articles: Article[];
  subCategories: any[];
  privateUsers: any[];
  autoApply: boolean;
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
  id: string;
}

interface SubCategory {
  id: string;
  name: string;
  slugUrl: string;
  ordinalNumber: number;
  icon?: any;
  isHighlight: boolean;
  access: string;
  articles: Article[];
}

interface Article {
  id: string;
  title: string;
  priority: string;
  reviewFrequency?: any;
  role?: any;
  businessUnit?: any;
  access: number;
  categoryId: string;
  content: string;
}

export interface IDataPopularTopic {
  id: string;
  title: string;
  priority: string;
  jobPosition?: any;
  businessUnit?: any;
  frequencyReview?: any;
  access: number;
  status: number;
  categoryId: string;
  content: string;
  slugUrl?: any;
  categorySlugUrl?: any;
  majorVersion: number;
  minorVersion: number;
  contributors: any[];
  feedbacks: any[];
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
  process: Process;
}

export interface IDataArticleDetail {
  id: string;
  title: string;
  priority: string;
  jobPosition: JobPosition;
  businessUnits: any[];
  frequencyReview: FrequencyReview;
  access: number;
  status: number;
  categoryId: string;
  content: string;
  slugUrl?: any;
  majorVersion: number;
  minorVersion: number;
  contributors: any[];
  feedbacks: any[];
  createdBy: string;
  modifiedBy: string;
  createdAt: string;
  modifiedAt: string;
  process: Process;
}

interface Process {
  processId: string;
  processName: string;
  functionId: string;
  functionName: string;
  slugNameProcess: string;
  ordinalNumberProcess: string;
}

interface FrequencyReview {
  frequency: number;
  timePeriod: string;
  id: string;
}

interface JobPosition {
  name: string;
  code?: any;
  id: string;
}

const useGetListCateGoryUserSide = () => {
  const {
    data: dataCategory,
    isLoading,
    isError,
  } = useGetCategoryUserSideQuery({});
  const [data, setData] = useState<IDataCategory[]>([]);

  useEffect(() => {
    // const newData = sortBy(dataCategory || [], ["ordinalNumber"]);
    // const newCategory = newData?.map((e: IDataCategory) => {
    //   return {
    //     ...e,
    //     subCategories: sortBy(e?.subCategories || [], ["ordinalNumber"]),
    //   };
    // });
    setData(dataCategory);
  }, [dataCategory]);

  return {
    isError,
    list: data,
    isLoading,
  };
};

export default useGetListCateGoryUserSide;

export const useGetListSubcategoryUserSide = (parentId: string | undefined) => {
  const {
    data: dataSubCategory,
    isLoading,
    isError,
    isFetching,
  } = useGetSubCategoryUserSideSlugUrlQuery(
    {
      ParentSlugUrl: parentId,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const { list: dataCategory } = useGetListCateGoryUserSide();
  const [data, setData] = useState<IDataSubCategory[]>([]);
  const [pathMenu, setPathMenu] = useState<{
    text?: string;
    redirectTo?: string;
    isHighlight: boolean;
  }>({
    text: "",
    redirectTo: "",
    isHighlight: false,
  });
  const [pathMenu2, setPathMenu2] = useState<
    { text?: string; redirectTo?: string; isHighlight: boolean } | undefined
  >();

  const [searchParams] = useSearchParams();
  const subId = searchParams.get("subId");

  useEffect(() => {
    // const sortData = sortBy(dataSubCategory || [], ["ordinalNumber"]);
    const objectActive =
      dataCategory &&
      dataCategory.find((i: IDataCategory) => i.slugUrl === parentId);
    if (subId) {
      const objectSubCate =
        dataSubCategory &&
        dataSubCategory.filter(
          (item: IDataSubCategory) => item.ordinalNumber === subId
        );
      const level1 = {
        text: objectActive?.name,
        redirectTo: ROUTERS_PATHS.SUBCATEGORIES.replace(
          ":slugUrl",
          objectActive?.slugUrl as string
        ),
        isHighlight: false,
      };
      const level2 = {
        text: objectSubCate && objectSubCate[0]?.name,
        redirectTo: ROUTERS_PATHS.SUBCATEGORIES.replace(
          ":slugUrl",
          objectActive?.slugUrl as string
        ),
        isHighlight: true,
      };
      setPathMenu(level1);
      setPathMenu2(level2);
      setData(objectSubCate);
    } else {
      setData(dataSubCategory);
      const level1 = {
        text: objectActive?.name,
        redirectTo: ROUTERS_PATHS.SUBCATEGORIES.replace(
          ":slugUrl",
          objectActive?.slugUrl as string
        ),
        isHighlight: true,
      };
      setPathMenu(level1);
      setPathMenu2(undefined);
    }
  }, [subId, dataSubCategory, parentId, dataCategory]);

  return {
    list: data,
    pathMenu,
    pathMenu2,
    isLoading: isFetching || isLoading,
    isError,
  };
};

export const useGetListArticleDetail = () => {
  const [dataArticleDetail] = useLazyGetArticlePuslishedBySlugUrlQuery();
  const [modifiedAt, setModifiedAt] = useState<string>("");
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getListVersionReviewSlugUrl = React.useCallback(
    async (url: string | undefined) => {
      if (!url) {
        return [];
      }
      const res: any = await dataArticleDetail({ url });
      const resultModifiedAt = res?.data?.modifiedAt;
      const updateString = resultModifiedAt
        ? `Last updated ${moment(resultModifiedAt).tz("Australia/Sydney").format("MMMM Do YYYY")}`
        : "";

      setModifiedAt(updateString);
      return res?.data || [];
    },
    []
  );

  return {
    getListVersionReviewSlugUrl,
    modifiedAt,
  };
};

export const useGetListArticleDetailId = () => {
  const [dataArticleDetailSlugUrl] = useLazyGetArticleBySlugUrlQuery();
  const [modifiedAt, setModifiedAt] = useState<string>("");

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const getListTopicSlugUrl = React.useCallback(async (params: any) => {
    const res: any = await dataArticleDetailSlugUrl(params);
    const resultModifiedAt = res?.data?.modifiedAt;
    const updateString = resultModifiedAt
      ? `Last updated ${moment(resultModifiedAt).tz("Australia/Sydney").format("MMMM Do YYYY")}`
      : "";
    setModifiedAt(updateString);
    return res?.data || [];
  }, []);

  return {
    getListTopicSlugUrl,
    modifiedAt,
  };
};

export const useGetListPopularTopic = () => {
  const [getPopularTopicUserSite] = useLazyGetPopularTopicQuery();
  const { showErrorMessageFromResponse } = useSetToastNotificationState();
  const getAllPopularTopic = React.useCallback(async (params: any) => {
    const res: any = await getPopularTopicUserSite(params);
    if (res?.error) {
      showErrorMessageFromResponse(res?.error);
    }
    return res?.data?.items;
  }, []);

  return {
    getAllPopularTopic,
  };
};

export const useGetSearchBar = (title?: string) => {
  const tableState = useGetCustomTableState();
  const { pageIndex, pageSize, sortField, sortDirection } = tableState;

  const payloadSearchBar = useMemo(
    () => ({
      Title: title,
      PageIndex: pageIndex + 1,
      PageSize: 200,
      OrderColumn: sortField,
      OrderDirection: sortDirection,
    }),
    [pageIndex, pageSize, sortField, sortDirection, title]
  );
  const { data, isLoading, error, isFetching, refetch } =
    useGetSearchBarQuery(payloadSearchBar);

  const searchList = useMemo(() => {
    return data?.items || [];
  }, [data]);

  return {
    list: searchList,
    total: data?.totalCount,
    isLoading,
    isFetching,
    refetch,
    // selectOptions,
  };
};
export const useLazyGetSearchBar = () => {
  const [lazyGetSearchBar, result] = useLazyGetSearchTitleQuery();
  const getSearchBarLoadMore = React.useCallback(
    async (params: GetAllRequest) => {
      const res = await getOptionsLoadMore(lazyGetSearchBar as any, params);
      const item = res?.options.map((x: any) => {
        return {
          ...x,
          url: `${x?.categorySlugUrl}/${x?.slugUrl}`,
        };
      });
      return { options: item, hasMore: res?.hasMore };
    },
    []
  );
  return {
    getSearchBarLoadMore,
    result,
  };
};
export const useCountSearch = () => {
  const [countSearch, { isLoading, error }] = useCountSearchMutation();
  return { countSearch, isLoading };
};
